import { buildDemoFreights } from '../../data/buildDemoFreights';

const summary = [
    { key: 'total', title: 'Total Freights', amount: 48, rate: '+12%', trend: 'up' },
    { key: 'bids', title: 'Bids Received', amount: 312, rate: '+18%', trend: 'up' },
    { key: 'verified', title: 'Verified Carriers', amount: 196, rate: '+22%', trend: 'up' },
    { key: 'action', title: 'Action Required', amount: 24, rate: '-8%', trend: 'down' },
    { key: 'rejected', title: 'Rejected Carriers', amount: 18, rate: '+5%', trend: 'up' },
];

const tabsCounts = {
    all: 48,
    open_for_bids: 12,
    in_verification: 18,
    closed: 14,
};

const sortFreights = (items, sortBy) => {
    const sortedItems = [...items];

    switch (sortBy) {
        case 'oldest':
            return sortedItems.sort((first, second) => first.createdAt.localeCompare(second.createdAt));
        case 'most_bids':
            return sortedItems.sort((first, second) => second.bids - first.bids);
        case 'fewest_bids':
            return sortedItems.sort((first, second) => first.bids - second.bids);
        case 'status':
            return sortedItems.sort((first, second) => first.status.localeCompare(second.status));
        case 'newest':
        default:
            return sortedItems.sort((first, second) => second.createdAt.localeCompare(first.createdAt));
    }
};

class CarrierGuardFreightsService {
    static getInstance() {
        return new CarrierGuardFreightsService();
    }

    async list({
        search = '',
        status,
        createdFrom,
        createdTo,
        sortBy = 'newest',
        pageIndex = 1,
        pageSize = 10,
    } = {}) {
        const freights = buildDemoFreights();
        const normalizedSearch = (search || '').trim().toLowerCase();

        const filteredFreights = freights.filter((freight) => {
            const matchesSearch = !normalizedSearch || [
                freight.reference,
                freight.cargo.type,
                `${freight.origin.city}, ${freight.origin.country}`,
                `${freight.destination.city}, ${freight.destination.country}`,
            ].some((value) => value.toLowerCase().includes(normalizedSearch));

            return matchesSearch
                && (!status || freight.status === status)
                && (!createdFrom || freight.createdAt >= createdFrom)
                && (!createdTo || freight.createdAt <= createdTo);
        });

        const sortedFreights = sortFreights(filteredFreights, sortBy);
        const offset = (pageIndex - 1) * pageSize;

        return {
            freights: sortedFreights.slice(offset, offset + pageSize),
            itemsCount: filteredFreights.length,
            summary,
            tabsCounts,
        };
    }
}

export default CarrierGuardFreightsService;
